import React from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Palestra/IMG_9287.jpg"
import foto2 from "../images/Palestra/IMG_9288.jpg"
import foto3 from "../images/Palestra/IMG_9289.jpg"
import foto4 from "../images/Palestra/IMG_1287.jpg"
import Titolo from "../commons/Titolo";
import PalestraAccordion from "../components/palestra/PalestraAccordion";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import CardMultitessere from "../components/CardMultitessere";
import TitoloSezioni from "../commons/TitoloSezioni";
import CardInEvidenza from "../components/spa/CardInEvidenza";
import promo from "../images/News/Promo_fine_stagione.png";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import barista from "../images/News/Barista.png";


function Palestra() {
    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto1} title={"Palestra"}/>
            <Space />
            <div style={{padding: "1em"}}>

            <PalestraAccordion />
            <Space />
            <figure className="text-center">
                <blockquote className="blockquote">
                    <p>
                        Accesso libero ai due ambienti: <strong>sala cardio</strong> e <strong>sala pesi</strong>
                        <br/>
                        <strong>Scheda personalizzata</strong> per tutti gli iscritti
                        <br/>
                        Personale di sala sempre presente
                        <br/>
                        <br/>
                        Gruppo organizzato giovanissimi 11-14 anni: martedì e venerdì dalle 17 alle 18
                    </p>
                </blockquote>
            </figure>
            <Space />
                <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4}/>
            <Space />
            <div className="d-flex flex-column text-center align-items-center justify-content-center">
                <TitoloSezioni title={"Multitessere"} />
                <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                <CardMultitessere />
            </div>
                <Space />
                <div className="m-auto" style={{maxWidth: "90%"}}>
                    <p style={{fontSize: "32px", fontFamily: "Hammersmith One"}}>In evidenza</p>
                    <hr/>
                    <div className="d-none d-sm-block" >
                        <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                            <CardInEvidenza foto={promo} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"../news/promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
                        </div>
                    </div>
                    <div className="d-sm-none  " >
                        <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>
                            <CardNewsEvidenza foto={promo} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"../news/promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
                        </div>
                    </div>

                </div>
            <Space />
            </div>
        </div>
    )
}


export default Palestra
